import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../../data/content";
import { SectionCTA } from "../SectionCTA";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-264" data-mp="3hfd1aizn98tm">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-265" data-mp="3r78zdu1qcyxu" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-266" data-mp="y30b7o0mcu">
      <div className="mx-auto max-w-5xl" data-id="element-267" data-mp="421i2vhw2ed0">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-navy md:text-5xl" data-id="element-268" data-mp="40zvbtrig3fg">
          What other dentists are <em className="italic text-brand" data-id="element-269" data-mp="e0qptvg2mifj">saying</em>
        </h2>
        <div className="mt-5 flex flex-col items-center gap-1" data-id="element-270" data-mp="e07g320kr0cl">
          <p className="font-serif text-5xl font-black text-navy" data-id="element-271" data-mp="2auamzn137o97">4.9<span className="text-2xl text-ink-muted" data-id="element-272" data-mp="2fsc80di2pxnb">/5</span></p>
          <Stars data-id="element-273" data-mp="2fsly0134c4t0" />
          <p className="mt-2 max-w-md text-center text-[16px] text-ink-muted" data-id="element-274" data-mp="2fu6sxrtchpre">Dentists are using the Playbook to bring more structure to their implant planning process.</p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-275" data-mp="1nshvd07rhqzo">
          {testimonials.map((t, i) => <li key={t.name} className={`flex flex-col rounded-3xl border border-navy/10 bg-canvas p-6 ${i === testimonials.length - 1 ? "md:col-span-2 md:mx-auto md:max-w-[calc(50%-10px)]" : ""}`} data-id="element-276" data-mp="1iuzmf9tqvbro" data-mpi={i}>
              <Stars data-id="element-277" data-mp="26jsj58i6xnnc" />
              <h3 className="mt-3 font-serif text-xl font-extrabold leading-snug text-navy" data-id="element-278" data-mp="26ldfn3o2fgnu">"{t.headline}"</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-ink-muted" data-id="element-279" data-mp="22hdxyhr1ubsw">"{t.quote}"</p>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-280" data-mp="1xikor1isp6yj">
                <img src={t.photo} alt={t.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-white" data-id="element-281" data-mp="r4361z8h6ozn" />
                <div data-id="element-282" data-mp="m47b0phra7w8">
                  <p className="font-bold text-ink" data-id="element-283" data-mp="m2vya06c1psz">{t.name}</p>
                  <p className="text-sm text-ink-muted" data-id="element-284" data-mp="nl4fwkcrvd7e">{t.country}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <SectionCTA label="I Want to Plan With Structure" data-id="element-285" data-mp="sjxpw2suom2t" />
      </div>
    </section>;
}